import Vue from 'vue'
import Vuex from 'vuex'
// import store from '@/store'
// import router from '@/router'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    userList: [],
  },
  getters: {
    userList(state) {
      return state.userList
    },
    realUserList(state) {
      let realUserList = state.userList.filter(userData => userData.test === '0');
      return realUserList;
    },
  },
  mutations: {
  },
  actions: {
  },
  modules: {}
}